import paymentService from '../../../_common/services/payment.service';

const LOAD_METHODS = 'loadMethods';
const CREATE_OPERATION = 'createOperation';
const UPDATE_LAST_OPERATION_STATUS = 'updateLastOperationStatus';
const SET_STATUS_TIMEOUT = 'setStatusTimeout';
const START_LAST_OPERATION_STATUS_UPDATING = 'startLastOperationStatusUpdating';
const STOP_LAST_OPERATION_STATUS_UPDATING = 'stopLastOperationStatusUpdating';

const SET_METHODS = 'setMethods';
const SET_LAST_OPERATION = 'setLastOperation';
const SET_OPERATION_OPTIONS = 'setOperationOptions';
const SET_LAST_OPERATION_SETTINGS = 'setLastOperationSettings';
const SET_LAST_OPERATION_AMOUNT = 'setLastOperationAmount';
const SET_LAST_OPERATION_TYPE = 'setLastOperationType';
const SET_LAST_OPERATION_STATUS = 'setLastOperationStatus';
const SET_LAST_OPERATION_STATUS_TIMEOUT = 'setLastOperationTimeout';
const SET_LAST_OPERATION_STATUS_INTERVAL = 'setLastOperationStatusInterval';

const state = {
    depositMethods: null,
    withdrawalMethods: null,

    lastOperation: null,
    operationOptions: null,
    lastOperationSettings: null,
    lastOperationAmount: null,
    lastOperationType: null,
    lastOperationStatus: null,
    lastOperationStatusTimeout: null,
    lastOperationStatusInterval: null,
}

const getters = {
    state: state => state,
    getDepositMethodByAlias: state => name => {
        if (!state.depositMethods) return null;
        const filtered = state.depositMethods.filter(i => i.alias && i.alias.toLowerCase() === name);
        return filtered.length > 0
            ? filtered[0]
            : null;
    },
    getWithdrawMethodByAlias: state => name => {
        if (!state.withdrawalMethods) return null;
        const filtered = state.withdrawalMethods.filter(i => i.alias && i.alias.toLowerCase() === name);
        return filtered.length > 0
            ? filtered[0]
            : null;
    },
    getHasLastOperation: state => {
        return state.lastOperation !== null;
    },
    getPhoneOperation: state => {
        if (!state.operationOptions) return null;

        return state.operationOptions.params
            && state.operationOptions.params.PhoneNumber;
    },
    getLastOperationAmount: state => {
        return state.lastOperationAmount;
    },
    getLastOperationType: state => {
        return state.lastOperationType;
    },
    getLastOperationStatus: state => {
        return state.lastOperationStatus
            ? state.lastOperationStatus.status
            : null;
    },
    getLastOperationTimeoutSeconds: state => {
        return state.lastOperationSettings
            ? state.lastOperationSettings.timeoutSeconds
            : null;
    },
    getLastOperationId: state => {
        return state.lastOperation
            ? state.lastOperation.id
            : null;
    },
    getReceiptId: state => {
        return state.lastOperationStatus
            ? state.lastOperationStatus.receiptId
            : null;
    }
}

const actions = {
    [LOAD_METHODS]: async ({commit, rootState}) => {
        const depositMethods = await paymentService.getPaymentMethods(rootState.player.balance.id, 'deposit');
        const withdrawalMethods = await paymentService.getPaymentMethods(rootState.player.balance.id, 'withdrawal');
        commit(SET_METHODS, { depositMethods, withdrawalMethods });
    },
    [CREATE_OPERATION]: async ({commit}, {method, type, balance, params, amount}) => {
        const result = await paymentService.createOperationAsync({
            amount: amount,
            currencyCode: balance.currency,
            paymentMethodId: method.methodId,
            inputParams: params,
            operationType: type,
            balanceId: balance.id
        });

        commit(SET_LAST_OPERATION, result);
        commit(SET_LAST_OPERATION_SETTINGS, method.settings);
        commit(SET_LAST_OPERATION_AMOUNT, amount);
        commit(SET_LAST_OPERATION_TYPE, type);
        return result;
    },
    [SET_OPERATION_OPTIONS]: async ({commit}, options) => {
        commit(SET_OPERATION_OPTIONS, options);
    },
    [UPDATE_LAST_OPERATION_STATUS]: async ({commit, dispatch, state}, ) => {
        if (state.lastOperationStatusTimeout != null
            && state.lastOperationStatusTimeout > new Date().getTime()
            && state.lastOperation) {
            const result = await paymentService.getStatusAsync(state.lastOperation.id);
            commit(SET_LAST_OPERATION_STATUS, result);
        } else {
            dispatch(SET_STATUS_TIMEOUT);
        }
    },
    [SET_STATUS_TIMEOUT]: async ({commit, dispatch, state}, ) => {
        dispatch(STOP_LAST_OPERATION_STATUS_UPDATING);
        commit(SET_LAST_OPERATION_STATUS, {
            id: state.lastOperation && state.lastOperation.id,
            receiptId: state.lastOperationStatus && state.lastOperationStatus.receiptId,
            type: '',
            status: 'timeout',
        });
    },
    [START_LAST_OPERATION_STATUS_UPDATING]: async ({commit, dispatch, state}) => {
        dispatch(STOP_LAST_OPERATION_STATUS_UPDATING);
        commit(SET_LAST_OPERATION_STATUS, null);
        const timeoutSeconds = (state.lastOperationSettings && state.lastOperationSettings.timeoutSeconds) || 200; // 200 - default
        commit(SET_LAST_OPERATION_STATUS_TIMEOUT, new Date().getTime() + 1000 * (Number(timeoutSeconds) + 40)); // betngo: timeoutSeconds, kiosk: +20, ui: +40
        const interval = setInterval(() => dispatch(UPDATE_LAST_OPERATION_STATUS), 1000*5);
        commit(SET_LAST_OPERATION_STATUS_INTERVAL, interval);
    },
    [STOP_LAST_OPERATION_STATUS_UPDATING]: async ({commit, state}) => {
        if (!state.lastOperationStatusInterval) return;
        clearInterval(state.lastOperationStatusInterval);
        commit(SET_LAST_OPERATION_STATUS_TIMEOUT, null);
        commit(SET_LAST_OPERATION_STATUS_INTERVAL, null);
    },
}

const mutations = {
    [SET_METHODS] (state, { depositMethods, withdrawalMethods }) {
        state.depositMethods = depositMethods;
        state.withdrawalMethods = withdrawalMethods;
    },
    [SET_LAST_OPERATION] (state, lastOperation) {
        state.lastOperation = lastOperation;
    },
    [SET_OPERATION_OPTIONS](state, operationOptions) {
        state.operationOptions = operationOptions;
    },
    [SET_LAST_OPERATION_SETTINGS](state, lastOperationSettings) {
        state.lastOperationSettings = lastOperationSettings;
    },
    [SET_LAST_OPERATION_AMOUNT] (state, lastOperationAmount) {
        state.lastOperationAmount = lastOperationAmount;
    },
    [SET_LAST_OPERATION_TYPE] (state, lastOperationType) {
        state.lastOperationType = lastOperationType;
    },
    [SET_LAST_OPERATION_STATUS] (state, lastOperationStatus) {
        state.lastOperationStatus = lastOperationStatus;
    },
    [SET_LAST_OPERATION_STATUS_TIMEOUT] (state, lastOperationStatusTimeout) {
        state.lastOperationStatusTimeout = lastOperationStatusTimeout
    },
    [SET_LAST_OPERATION_STATUS_INTERVAL] (state, lastOperationStatusInterval) {
        state.lastOperationStatusInterval = lastOperationStatusInterval;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./skins/xkiosk/data/payment.js